import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12 14.379a.821.821 0 0 1-.298-.053.79.79 0 0 1-.268-.184L7.046 9.754a.503.503 0 0 1-.15-.345.466.466 0 0 1 .15-.363.49.49 0 0 1 .354-.16.49.49 0 0 1 .354.16L12 13.292l4.246-4.246a.502.502 0 0 1 .345-.15.467.467 0 0 1 .363.15.49.49 0 0 1 .16.354.49.49 0 0 1-.16.354l-4.389 4.388a.79.79 0 0 1-.267.184.821.821 0 0 1-.298.053Z" }, null, -1)
  ]))]))
}
export default { render: render }